import { useMutation } from '@tanstack/react-query';
import { getAxios } from '../../../util/axios';
import { apiRoutes } from '../../../constants/apiRoutes';

export function useStartAuctionMutation() {
  return useMutation({
    mutationFn: async (props: { auctionId: number }) => {
      return await getAxios().post(apiRoutes.auctioneer.start(props.auctionId));
    }
  });
}
